export default __webpack_public_path__ + "static/media/warning-icon.c2ff2f9a.png";